import { Component, ElementRef, Input, AfterViewInit, OnDestroy, inject, Renderer2 } from '@angular/core'
import { TranslateModule, TranslateService } from '@ngx-translate/core'
import { NgClass } from '@angular/common'
import { TooltipModalService } from '../tooltip-modal.service'

@Component({
  selector: 'app-tooltip',
  standalone: true,
  imports: [TranslateModule, NgClass],
  template: `
    <div class="position-absolute tutorial-info pointer-style" [ngClass]="{ 'position-absolute': isAbsolute }">
      <div class="icon-wrapper">
        @if (isModal) {
          <i
            class="bi text-primary bi-info-circle-fill ms-2"
            role="button"
            tabindex="0"
            aria-label="Plus d’informations"
            (click)="openModal()"
            (keydown.enter)="openModal()"
          ></i>
        } @else {
          <i
            #tooltipTarget
            class="bi ms-2 text-primary bi-info-circle-fill custom-tooltip"
            role="button"
            tabindex="0"
            aria-label="Informations complémentaires"
          ></i>
        }
      </div>
    </div>
  `,
  styles: `
    .tutorial-info {
      top: 50%;
      right: 10px;
      transform: translateY(-50%);
    }
  `,
})
export class TooltipComponent implements AfterViewInit, OnDestroy {
  @Input() text: string = ''
  @Input() title: string = ''
  @Input() isModal = false
  @Input() isAbsolute = true

  private tooltipInstance: { toggle(): void; hide(): void; dispose(): void } | null = null
  private removeClickListener: (() => void) | null = null

  tooltipModalService = inject(TooltipModalService)
  translateService = inject(TranslateService)
  private renderer = inject(Renderer2)

  constructor(private el: ElementRef) {}

  ngAfterViewInit() {
    import('bootstrap').then(bootstrap => {
      const tooltipTrigger: HTMLElement | null = this.el.nativeElement.querySelector('.custom-tooltip')

      if (tooltipTrigger) {
        this.translateService.get(this.text).subscribe(translatedText => {
          // Création du tooltip en mode manuel
          this.tooltipInstance = new bootstrap.Tooltip(tooltipTrigger, {
            html: true,
            title: translatedText,
            trigger: 'manual',
            placement: 'top',
          })

          // Toggle au clic (sans stopPropagation !)
          tooltipTrigger.addEventListener('click', () => {
            this.tooltipInstance?.toggle()
          })

          // Fermer si clic en dehors
          this.removeClickListener = this.renderer.listen('document', 'click', (event: MouseEvent) => {
            if (tooltipTrigger && !tooltipTrigger.contains(event.target as Node)) {
              this.tooltipInstance?.hide()
            }
          })
        })
      }
    })
  }

  ngOnDestroy() {
    if (this.removeClickListener) {
      this.removeClickListener()
      this.removeClickListener = null
    }
    if (this.tooltipInstance) {
      this.tooltipInstance.dispose()
    }
  }

  openModal() {
    this.tooltipModalService.openTooltipModal(this.text, this.title)
  }
}
